module.exports = __webpack_public_path__ + "img/bookings.146b4dfc.png";